export default {"src":"/_next/static/media/blues-logomark.4060a35c.svg","height":446,"width":1722,"blurWidth":0,"blurHeight":0};